import { render, staticRenderFns } from "./batchnotification_list.vue?vue&type=template&id=828c05d6&scoped=true&"
import script from "./batchnotification_list.vue?vue&type=script&lang=js&"
export * from "./batchnotification_list.vue?vue&type=script&lang=js&"
import style0 from "./batchnotification_list.vue?vue&type=style&index=0&id=828c05d6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828c05d6",
  null
  
)

export default component.exports